module.exports = __webpack_public_path__ + "img/curve2.c879b1e0.svg";